import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import { connect } from "react-redux";
import PopupWrapper from "../components/PopupWrapper";
import Spacer from "../components/Spacer";
import AccountSubheader from "../components/AccountSubheader";
import AccountBackButton from "../components/AccountBackButton";
import { Field, reduxForm, FieldArray } from "redux-form";
import { accountHomeViewActions } from "../_actions";
import { withCookies } from "react-cookie";
import { styles as selectStyles } from "../components/SelectMenuStyles";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";

const validate = (values, allValues) => {
  const errors = {};

  const ratesArrayErrors = [];

  values.rates !== null &&
    values.rates[0] != undefined &&
    values.rates.map((rate, index) => {
      const ratesErrors = {};

      if (rate.unit_price >= 1) {
        ratesErrors.unit_price = "Price must be under 1";
        ratesArrayErrors[index] = ratesErrors;
      }
    });
  if (ratesArrayErrors.length) {
    errors.rates = ratesArrayErrors;
  }

  // return errors;
};

const renderError = (props) => {
  const {
    meta: { touched, error, warning },
  } = props;
  return (
    <div>
      {touched &&
        ((error && <span className={css(styles.error)}>{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  );
};

const renderField = (props) => {
  const {
    input,
    label,
    type,
    className,
    meta: { touched, error, warning },
  } = props;

  const inputStyles = css([
    styles.input,
    touched && error && styles.inputError,
  ]);
  return (
    <div className={className}>
      <label className={css(styles.label)}>{label}</label>
      <div>
        <input
          {...input}
          placeholder={label}
          type={type}
          required
          className={inputStyles}
        />
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );
};

const renderSelectMenu = (props) => {
  // let $select = jQuery("#bmg_monday_start_hour");
  const {
    input,
    label,
    type,
    className,
    meta: { touched, error, warning },
  } = props;

  let options = [];
  options.push(
    <option value="" selected disabled hidden>
      Choose time
    </option>
  );

  for (let hr = 0; hr < 24; hr++) {
    let hrStr = hr.toString().padStart(2, "0") + ":";

    let val = hrStr + "00";
    options.push(
      <option val={parseInt(String(val).replace(":", ""))}>{val}</option>
    );

    val = hrStr + "30";
    options.push(
      <option val={parseInt(String(val).replace(":", ""))}>{val}</option>
    );
  }

  return (
    <div>
      <label className={css(styles.label)}>Start time</label>

      <div className={css(selectStyles.selectWrapper)}>
        <select
          required
          className={css(selectStyles.select)}
          value={7}
          {...input}
        >
          {options}
        </select>
        <span className={css([selectStyles.hideOnMobile, selectStyles.arrow, selectStyles.arrowCenter])}>
          <span className={css(selectStyles.changeText)}>{`Time`}</span>
        </span>
      </div>
    </div>
  );
};

class AccountHomeViewTariffEditTimeRates extends Component {
  constructor(props) {
    super(props);

    const user = JSON.parse(localStorage.getItem("user"));
    const level = props.match.params.level;
    if (level == "infocare") {
      user.user_id = user.dependant_user_id;
    }

    this.props.dispatch(accountHomeViewActions.getTariff(user));

    this.state = {
      time: props.match.params.time,
      rate: props.match.params.rate,
      level: props.match.params.level,
      user_id: user.user_id,
      submitted: false,
    };

    this.renderRateCard = this.renderRateCard.bind(this);
    this.submit = this.submit.bind(this);
  }

  renderRateCard({ fields }) {
    let renderAddRate = () => {
      return (
        <div className={css(styles.addLinkWrapper)}>
          <button
            type="button"
            onClick={() => {
              fields.push({});
            }}
            className={css([styles.link, styles.addLink])}
          >
            {" "}
            <img
              src={"/icons/add.svg"}
              className={css(styles.linkIcon)}
              alt=""
            />
            Add New Rate
          </button>
        </div>
      );
    };

    // Always show 1 field
    // if (fields.length === 0) fields.push({});

    if (fields.length === 0) {
      return (
        <>
          <div className={css(styles.unitsWarning)}>
            <img src={"/icons/AlertIcon.svg"} alt="" />
            <p
              className={css([styles.microcopy, styles.unitsWarningMicrocopy])}
            >
              No rates have been added. Saving now will apply the default rate.
            </p>
          </div>{" "}
          {renderAddRate()}
        </>
      );
    }

    return (
      <div>
        {fields.map((rate, index) => (
          <>
            <div className={css(styles.dataWrapper)} key={index}>
              <div className={css(styles.twoColumn)}>
                <h3 className={css(styles.dataWrapperTitle)}>
                  {(this.props.accountHomeViewTariffEditTimeRates &&
                    this.props.accountHomeViewTariffEditTimeRates.values.rates[
                      index
                    ] &&
                    this.props.accountHomeViewTariffEditTimeRates.values.rates[
                      index
                    ].unit_name) ||
                    "Enter rate name..."}
                </h3>

                <button
                  type="button"
                  onClick={() => {
                    fields.remove(index);
                  }}
                  className={css(styles.link)}
                >
                  Remove
                </button>
              </div>

              <Field
                name={`${rate}.unit_name`}
                component={renderField}
                label="Name"
              />
              <div className={css(styles.twoColumn)}>
                <Field
                  name={`${rate}.unit_price`}
                  component={renderField}
                  type={"number"}
                  label="Unit price (£)"
                  className={css([
                    styles.twoColumnItem,
                    styles.twoColumnItemLeading,
                  ])}
                />

                <div className={css(styles.twoColumnItem)}>
                  <Field
                    name={`${rate}.start_time`}
                    component={renderSelectMenu}
                    label="Start time"
                  />
                </div>
              </div>
            </div>
          </>
        ))}
        {renderAddRate()}
      </div>
    );
  }

  submit = (values) => {
    let request;

    if (values.rates === null || values.rates.length === 0) {
      request = { [this.state.rate]: null };
    } else {
      const output = {
        times: [],
        prices: [],
        rate_names: [],
      };

      values.rates.map((x) => {
        output.rate_names.push(x.unit_name);
        output.times.push(x.start_time);
        output.prices.push(x.unit_price);
      });

      request = {
        [this.state.rate]: [
          {
            days: this.state.time,
            prices: output.prices.map((price) => {
              return parseFloat(price);
            }),
            times: output.times.map((time) => {
              return parseInt(String(time).replace(":", ""));
              // return time;
            }),
            rate_names: output.rate_names,
          },
        ],
      };
    }

    return this.props.dispatch(
      accountHomeViewActions.setTariff(this.state.user_id, request)
    );
  };
  capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      submitSucceeded,
      submitFailed,
    } = this.props;

    if (submitSucceeded && !this.state.submitted) {
      this.setState({
        submitted: true,
      });
    }

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton history={this.props.history} />
        </header>
        <main className={css(styles.mainContainer)}>
          <AccountSubheader
            backLabel="Tariff"
            backHref={`/account/${this.state.level}/tariff/edit-time/${this.state.time}/${this.state.rate}`}
            title={`${this.capitaliseFirstLetter(this.state.rate)} Rates`}
          />
          <h2 className={css(styles.label)}>When do these rates apply?</h2>

          <form onSubmit={handleSubmit(this.submit)}>
            <Spacer />

            <FieldArray
              name="rates"
              number={2}
              component={this.renderRateCard}
            />

            <button
              type="submit"
              disabled={submitting}
              className={css(styles.buttonGreen)}
            >
              Save Rates
            </button>
          </form>
          <div>
            <Field name="hidden_field" component={renderError} />
          </div>
          {this.state.submitted && (
            <SuccessMessage
              message={[
                "Rates saved. Go to ",
                <a
                  href={`/account/${this.state.level}/tariff`}
                  className={css(styles.link)}
                >
                  Tariff home
                </a>,
              ]}
            />
          )}
          {submitFailed && <ErrorMessage message="Could not save rates" />}
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  let rates = state.accountHomeView.detail[props.match.params.rate];

  const ratesArr =
    rates !== undefined &&
    rates &&
    rates[0].prices.map((price, index) => {
      let timePadded = pad(rates[0].times[index], 4);
      let timeWithSemicolon =
        timePadded.slice(0, 2) + ":" + timePadded.slice(2);

      return {
        unit_price: price,
        unit_name: rates[0].rate_names[index],
        start_time: timeWithSemicolon,
      };
    });

  const initialValues = {
    rates: ratesArr,
  };

  return {
    initialValues,
    detail: { ...state.accountHomeView.detail },
    ...state.form,
    // ...state,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "accountHomeViewTariffEditTimeRates",
    destroyOnUnmount: false,
    enableReinitialize: true,
    validate,
  })(withCookies(AccountHomeViewTariffEditTimeRates))
);
